import { Component, OnInit, Input } from '@angular/core';
import { CpMarketplaceApiService } from '../../services/cp-marketplace-api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewDocsModalComponent } from '../../shared/view-docs-modal/view-docs-modal.component';
import { SharedDataService } from '../../services/shared-data.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-view-cp-documents',
  templateUrl: './view-cp-documents.component.html',
  styleUrls: ['./view-cp-documents.component.scss']
})

export class ViewCpDocumentsComponent implements OnInit {

  @Input() cpDocs = null;

  constructor(
    private apiService: CpMarketplaceApiService,
    private modalService: NgbModal,
    private sharedData: SharedDataService,
  ) { }

  ngOnInit() {
  }

  showCPDocuments() {
    if (this.cpDocs && Object.keys(this.cpDocs).length) {
      this.showInputDocs(this.cpDocs);
    } else {
      this.fetchAndShowCPDocs();
    }
  }

  showInputDocs(docsObj) {
    const docsToView = [];

    if (docsObj.BoardResolutionCP_board_resolution) {
      docsToView.push({
        title: 'Board Resolution',
        document_url: docsObj.BoardResolutionCP_board_resolution
      });
    }

    if (docsObj.docdata_signatories_doc_location) {
      docsToView.push({
        title: 'Authorised Signatories List',
        document_url: docsObj.docdata_signatories_doc_location
      });
    }

    if (docsObj.issueCreditRatingDetails && docsObj.issueCreditRatingDetails.length) {
      docsToView.push(...docsObj.issueCreditRatingDetails.map(letter => {
        return {
          title: 'Credit Rating Letter',
          additionalData: `${letter.name_of_credit_rating_agency} ${letter.credit_rating}`,
          document_url: letter.credit_rating_document
        };
      }));
    }

    if (docsToView.length) {
      const modalRef = this.modalService.open(ViewDocsModalComponent, { backdrop: 'static', keyboard : false });
      modalRef.componentInstance.docsToView = docsToView;
    }
  }

  fetchAndShowCPDocs() {
    const docsToView = [];

    forkJoin([
      this.apiService.getBoardResolution(),
      this.apiService.getSignatories(),
      this.apiService.getCreditRatings()
    ]).subscribe((results: any) => {

      // results[0] is board resolution
      if (results[0].length) {
        if (results[0][0].board_resolution) {
          docsToView.push({
            title: 'Board Resolution',
            document_url: results[0][0].board_resolution
          });
        }
      }
      // results[1] is Signatories list
      if (results[1].length) {
        docsToView.push({
          title: 'Signatories List',
          document_url: results[1][0].doc_location
        });
      }
      // results[2] is credit ratings
      if (results[2].length) {
        docsToView.push(...results[2].map(letter => {
          return {
            title: 'Credit Rating Letter',
            additionalData: `${letter.name_of_credit_rating_agency} ${letter.credit_rating}`,
            document_url: letter.credit_rating_document
          };
        }));
      }

      if (docsToView.length) {
        const modalRef = this.modalService.open(ViewDocsModalComponent, { backdrop: 'static', keyboard : false });
        modalRef.componentInstance.docsToView = docsToView;
      }
    });
  }
}
